<template>
  <Vfm :show="show" @onclose="handleClose" class="z-2000" :class="[show ? '' : 'none']">
    <div class="absolute t-0 b-0 l-0 r-0 flex justify-center items-center" @click="handleClose">
      <div class="bg-color-page" style="width: 90%;" @click.stop>
        <!-- 头部 -->
        <div class="flex items-center justify-between px-14 py-14 bg-color-linear-12">
          <span class="text-15 font-700 text-color-0">{{ $t("A0307") }}</span><i @click.stop="handleClose"
            class="inline-block h-[max-content] w-[max-content] icon sysicon-new-clean-3 text-color-2 text-15 "></i>
        </div>
        <div class="flex-1 overflow-y-auto px-40 py-40">
          <PhoneFormInput v-model="applyCode" type="text" :placeholder="$t('A0344')" />
          <button @click.stop="handleApplyBonus"
            class="bg-color-main text-12 text-color-0 font-700 h-full px-30 rounded-6 shrink-0 h-40 w-full "
            style="margin-top: 20px !important;"
            :class="[applyCode ? '' : 'opacity-70 pointer-events-none']">
            {{ $t("A0041") }}
          </button>
        </div>
      </div>
    </div>
  </Vfm>
</template>

<script setup>
import { getCurrentInstance } from "vue";
const { proxy } = getCurrentInstance();

import { apiApplyBonus } from "@/api";

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
});
const applyCode = ref("");

const emit = defineEmits(["onclose"]);
function handleClose() {
  applyCode.value = ''
  emit("onclose");
}

// 申请活动奖励
async function handleApplyBonus() {
  proxy.$Loading.show(); // 显示 loading
  try {
    const { data, msg, code } = await apiApplyBonus({
      code: applyCode.value
    });
    // console.log(data);
    proxy.$Toast(msg);
    handleClose();
  } catch (error) {
  } finally {
    proxy.$Loading.hide(); // 显示 loading
  }
}
</script>

<style scoped></style>
